module.exports = __webpack_public_path__ + "img/chevron-right.0562f994.svg";